import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IVerticalScrollableProps {
  earWidth?: number;
  horizontalAlign?: boolean;
  fullWidth?: boolean;
}

export function VerticalScrollable({
  children,
  horizontalAlign,
  fullWidth,
  earWidth,
}: React.PropsWithChildren<IVerticalScrollableProps>) {
  const scrollRef = React.useRef<HTMLUListElement>(null);
  React.useEffect(() => {
    /* istanbul ignore else */
    if (scrollRef.current && scrollRef.current.scrollBy) {
      scrollRef.current.scrollBy(0, 0);
    }
  }, []);
  const childCount = React.Children.count(children);

  return (
    <div className={classNames(styles['hidden'], horizontalAlign && styles['align'], fullWidth && styles['fullwidth'])}>
      <ul className={styles['container']} ref={scrollRef}>
        {React.Children.map(
          children,
          (child, i) =>
            child && (
              <li
                key={i}
                className={classNames(styles['item'])}
                style={{
                  width: childCount > 1 && typeof earWidth !== 'undefined' ? `calc(100% - ${earWidth}px)` : undefined,
                }}
              >
                {child}
              </li>
            ),
        )}
      </ul>
    </div>
  );
}
